<div class="row animated fadeIn">
  <div class="col-md-12">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/orderReview/orderreview"><span
            class="mdi mdi-arrow-left"></span></a> Details Order Review</h4>

    </div>
    <div class="card">
      <div class="card-body new-detail-page">
        <ngb-tabset #t="ngbTabset" [(activeId)]="activeTab">
          <ngb-tab id="tab-selectbyid9">
            <ng-template ngbTabTitle>
              <div (click)="tabclick2(id)">
                Details Order Review
              </div>
            </ng-template>
            <ng-template ngbTabContent>
              <form>
                <div
                  class="mt-3 mb-3 border-bottom w-100 d-flex flex-wrap justify-content-between align-items-center pb-2">
                  <h5 class="text-green mb-0">Order Information</h5>

                  <div class="mb-2 mb-md-0 pt-1">
                    <span
                      *ngIf="permission.OrderReview_Edit==1 && ((formdata.QuotationEngineer == userId || formdata.CommercialExecutive == userId || formdata.SalesEngineer == userId || formdata.SalesManager == userId || formdata.FinanceManager == userId || formdata.GeneralManager == userId || formdata.CreatedBy == userId) || userRId==1) && (formdata.CurrentStageName != 'PO / Contract Cancelled' && formdata.CurrentStageName != 'Job Closed')">
                      <button type="button" class="btn btn-outline-info mr-3" (click)="edit(id)">
                        <span>Edit Order Review</span>
                      </button>
                    </span>

                    <button type="button" class="btn btn-outline-info" (click)="openClosefun()">
                      <span *ngIf="!isCollapsed"><i class="mdi mdi-chevron-down"></i></span>
                      <span *ngIf="isCollapsed"><i class="mdi mdi-chevron-up"></i></span>
                    </button>
                  </div>
                </div>

                <div class="form-row odd">
                  <div class="form-group col-lg-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-6 col col-form-label text-right">MTI Number :</label>
                      <div class="col-sm-6 col">
                        <p class="pt-2 m-0 font-weight-bold">{{ formdata.MTINumber }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-6 col col-form-label text-right">Status :</label>
                      <div class="col-sm-6 col">
                        <p class="pt-2 m-0 font-weight-bold">{{ formdata.StatusName }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-6 col col-form-label text-right">Stages :</label>
                      <div class="col-sm-6 col">
                        <p class="pt-2 m-0 font-weight-bold">{{ formdata.CurrentStageName }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row even">
                  <div class="form-group col-lg-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-6 col col-form-label text-right">SO Options are :</label>
                      <div class="col-sm-6 col">
                        <p class="pt-2 m-0 font-weight-bold">{{ formdata.SOOptionName }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-6 col col-form-label text-right">Critical Shipment :</label>
                      <div class="col-sm-6 col">
                        <p class="pt-2 m-0 font-weight-bold">{{ formdata.CriticalShipment }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-6 col col-form-label text-right">Project Name (Project ID):</label>
                      <div class="col-sm-6 col">
                        <p class="pt-2 m-0 font-weight-bold">{{ formdata.ProjectName }} ({{ formdata.ProjectNumber }})
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row odd">
                  <div class="form-group col-lg-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-6 col col-form-label text-right">Inquiry Name (Inquiry ID) :</label>
                      <div class="col-sm-6 col">
                        <p class="pt-2 m-0 font-weight-bold">{{ formdata.InquiryName }} ({{ formdata.InquiryNumber }})
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-6 col col-form-label text-right">Client Name :</label>
                      <div class="col-sm-6 col">
                        <p class="pt-2 m-0 font-weight-bold">{{ formdata.ClientName }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-6 col col-form-label text-right">Business Vertical :</label>
                      <div class="col-sm-6 col">
                        <p class="pt-2 m-0 font-weight-bold">{{ formdata.BusinessVerticalName }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="" *ngIf="isCollapsed">

                  <div class="form-row even">
                    <div class="form-group col-lg-4 col-sm-12">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">Business Category :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.BusinessCategory }}</p>
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-lg-4 col-sm-12">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">Client SO / AGR # (Received) :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.ClientSOAGR }}</p>
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-lg-4 col-sm-12" *ngIf="formdata.ClientSOAGR == 'Yes'">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">Client SO Number</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.ClientSONumber }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row odd">
                    <div class="form-group col-lg-4 col-sm-12" *ngIf="formdata.ClientSOAGR == 'Yes'">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">Client SO Date:</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.ClientSODate }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12" *ngIf="formdata.ClientSOAGR == 'Yes'">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">SO Received Date (Actual) :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.SOReceivedDate }}</p>
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-lg-4 col-sm-12" *ngIf="formdata.ClientSOAGR == 'No'">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">Client SO Expected Date :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.ClientSOExpDate }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row even">
                    <div class="form-group col-lg-4 col-sm-12">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">SO Remarks :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.RemarksSOReceiveDate }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">SO Acknowledgement :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.SOAcknowledgementName }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">Project Execution :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.ProjectExecutionName }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row odd">
                    <div class="form-group col-lg-4 col-sm-12">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">Equipment Delivery Date :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.EquipmentDeliveryDate }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">Equipment Delivery Remarks :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.EquipmentDeliveryRemark }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">Scope of Work :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.ScopeOfWork }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row even">
                    <div class="form-group col-lg-4 col-sm-12">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">Consultant Approval :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.ConsultantApproval == 1 ? 'Applicable' : 'Not
                            Applicable' }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12" *ngIf="formdata.ConsultantApproval == 0">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">Consultant Approval Reason :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.ConsultantApprovalRemark }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">Remark :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{ formdata.Remark }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="commercialdata != null">
                    <div class="pb-1 mt-3 mb-3 border-bottom w-100">
                      <h5 class="text-green">Commercial Information</h5>
                    </div>

                    <div class="form-row even">

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Inco Terms :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.Name }}</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Mode of Shipment :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.ModeOfShipmentName }}</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">SO Contract Base Value :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.SOContractBaseValue }}
                              ({{currency}})
                            </p>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="form-row odd">

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">SO Reported Value :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.SOReportedValue }} (QAR)</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row" *ngIf="commercialdata.ClientPaymentCurrency == 'Base'">
                          <label class="col-sm-6 col col-form-label text-right">Client Payment Currency :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.ClientPaymentCurrency }}
                              ({{currency}})</p>
                          </div>
                        </div>
                        <div class="row" *ngIf="commercialdata.ClientPaymentCurrency == 'Reported'">
                          <label class="col-sm-6 col col-form-label text-right">Client Payment Currency :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.ClientPaymentCurrency }} (QAR)</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Advance & LC :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.AdvanceAndLC ? 'Applicable' : 'Not
                              Applicable' }}</p>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="form-row even">

                      <div class="form-group col-lg-4 col-sm-12" *ngIf="commercialdata.AdvanceAndLCName != null">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Advance And LC Name :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.AdvanceAndLCName }}</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-lg-4 col-sm-12" *ngIf="commercialdata.ALCReceivedName != null">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Is Advance / LC received :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.ALCReceivedName}}</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-lg-4 col-sm-12" *ngIf="commercialdata.LCNumber != null">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">LC Number :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.LCNumber }}</p>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="form-row odd">

                      <div class="form-group col-lg-4 col-sm-12"
                        *ngIf="commercialdata.LCValue != null && commercialdata.LCValue != 0">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">LC Value :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.LCValue }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-lg-4 col-sm-12" *ngIf="commercialdata.IssuedDate != null">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Issued Date :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.IssuedDate }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-lg-4 col-sm-12" *ngIf="commercialdata.ExpiryDate != null">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Expiry Date :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.ExpiryDate }}</p>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="form-row even">

                      <div class="form-group col-lg-4 col-sm-12" *ngIf="commercialdata.ExpectedDate != null">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Expected Date :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.ExpectedDate }}</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-lg-4 col-sm-12"
                        *ngIf="commercialdata.AdvanceAmt != null && commercialdata.AdvanceAmt != 0">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Advance Amount :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.AdvanceAmt }} (QAR)</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-lg-4 col-sm-12" *ngIf="commercialdata.ReceivedDate != null">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Received Date :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.ReceivedDate }}</p>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="form-row odd">

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Project Margin (%) :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.ProjectMargin }} ({{currency}})
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Project Start Date:</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.ProjectStartDate }}</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Project Completion Date :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.ProjectCompletionDate }}</p>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="form-row even">

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Credit Split (%) :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{ commercialdata?.CreditSplit ? 'Yes' : 'No' }}</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div *ngIf="payFormdata != null">
                    <div class="pb-1 mt-3 mb-3 border-bottom w-100">
                      <h5 class="text-green">Payment Terms</h5>
                    </div>

                    <div class="form-row odd">
                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Client Registration form is it
                            Required
                            :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{payFormdata?.ClientRegistrationName}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-lg-4 col-sm-12" *ngIf="payFormdata.ReceivedDate != null">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Received Date :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{payFormdata?.ReceivedDate}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-lg-4 col-sm-12" *ngIf="payFormdata.ExpectedDate != null">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Expected Date:</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{payFormdata?.ExpectedDate}}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-row even">

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Warranty :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{payFormdata?.Warranty ? 'Yes' : 'No'}}</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Supplier PO :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{payFormdata?.SupplierPO ? 'Yes' : 'No'}}</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Sub Contractor PO/ AGR :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{payFormdata?.SubContractor ? 'Yes' : 'No'}}</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div *ngIf="requirementdata != null">
                    <div class="pb-1 mt-3 mb-3 border-bottom w-100">
                      <h5 class="text-green">Special Project Requirements</h5>
                    </div>

                    <div class="form-row odd">
                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Special Requirements in Inquiry
                            :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{requirementdata?.SpecialRequirement}}</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group  col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Risk Involved :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{requirementdata?.RiskInvolved ? 'Yes' : 'No'}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group  col-lg-4 col-sm-12" *ngIf="requirementdata.RiskInvolved == true">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Risk Remarks :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{requirementdata?.RiskRemark}}</p>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="form-row even">
                      <div class="form-group col-lg-4 col-sm-12" *ngIf="requirementdata.RiskInvolved == true">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Risk Mitigation Plan :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{requirementdata?.RiskMitigationPlan}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Penalties :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{requirementdata?.Penalties ? 'Yes' : 'No'}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-lg-4 col-sm-12" *ngIf="requirementdata.Penalties == true">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Penalties Remarks :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{requirementdata?.PenaltiesRemark}}</p>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="form-row odd">
                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Deviation Contract :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{requirementdata?.DeviationContract ? 'Yes' : 'No'}}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-lg-4 col-sm-12" *ngIf="requirementdata.DeviationContract == true">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Deviation Contract Remarks :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{requirementdata?.DeviationContractRemark}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Retention :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{requirementdata?.Retention ? 'Yes' : 'No'}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row even" *ngIf="requirementdata && requirementdata.Retention == true">
                    <div class="form-group col-lg-4 col-sm-12">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">Retention Remarks :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{requirementdata?.RetentionRemark}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12">
                      <div class="row">
                        <label class="col-sm-6 col col-form-label text-right">PBG/Gaurantee Cheque :</label>
                        <div class="col-sm-6 col">
                          <p class="pt-2 m-0 font-weight-bold">{{requirementdata?.PBGGaurantee ? 'Yes' : 'No'}}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="formdata.QuotationEngineerName != null && formdata.CommercialExecutiveName != null && formdata.SalesEngineerName != null && formdata.SalesManagerName != null && formdata.FinanceManagerName != null && formdata.GeneralManagerName != null">
                    <div class="pb-1 mt-3 mb-3 border-bottom w-100">
                      <h5 class="text-green">Prepared By / Assigned to / Approved by</h5>
                    </div>
                    <div class="form-row odd">
                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Quotation Engineer :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{formdata.QuotationEngineerName}}
                              ({{formdata.QuotationEngineerId}})</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Commercial Executive :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{formdata.CommercialExecutiveName}}
                              ({{formdata.CommercialExecutiveId}})</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Sales Engineer :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{formdata.SalesEngineerName}}
                              ({{formdata.SalesEngineerId}})</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-row even">
                      <div class="form-group col-lg-4 col-sm-12" *ngIf="formdata.SalesManagerName != null">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Sales Manager :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{formdata.SalesManagerName}}
                              ({{formdata.SalesManagerId}})</p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group  col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">Finance Manager :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{formdata.FinanceManagerName}}
                              ({{formdata.FinanceManagerId}})</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-lg-4 col-sm-12">
                        <div class="row">
                          <label class="col-sm-6 col col-form-label text-right">General Manager :</label>
                          <div class="col-sm-6 col">
                            <p class="pt-2 m-0 font-weight-bold">{{formdata.GeneralManagerName}}
                              ({{formdata.GeneralManagerId}})</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </form>

              <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                <li [ngbNavItem]="1" *ngIf="itemData != null">
                  <a ngbNavLink>Item Details</a>
                  <ng-template ngbNavContent>
                    <div class="form-group">
                      <div class="table-responsive">

                        <table class="table" aria-hidden="true">
                          <thead>
                            <tr>
                              <th colspan="13" id="" class="text-center">Item Details</th>
                              <th id="" colspan="3" class="text-center">Execution</th>
                              <th id="" class="text-center">War</th>
                            </tr>
                            <tr>
                              <th id="">Business Vertical</th>
                              <th id="">Business Category</th>
                              <th id="" style="width:130px;">Model / ITEM Name</th>
                              <th id="">Description</th>
                              <th id="">Brand</th>
                              <th id="" class="text-right">Unit Type</th>
                              <th id="" class="text-right">Inq. Qty</th>
                              <th id="" class="text-right">Order Qty</th>
                              <th id="" class="text-right">Unit Rate</th>
                              <th id="" class="text-right">DISCOUNT RATE %<br> & Amt</th>
                              <th id="" style="width:130px;">Total W/O Vat</th>
                              <th id="" style="min-width:110px;">Tax % AMT</th>
                              <th id="" style="width:130px;">Total Price</th>
                              <th id="" class="text-center" style="vertical-align:super">Inst</th>
                              <th id="" class="text-center" style="min-width:75px;vertical-align:super">T & C</th>
                              <th id="" class="text-center" style="min-width: 75px;">H O</th>
                              <th id="" class="text-center" style="vertical-align:super">War</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td [attr.colspan]="12" class="p-1 font-12 font-w text-right">
                                <span>Freight Amount </span>
                              </td>
                              <td class="p-1 font-12 font-w text-right">
                                <span *ngIf="currency != 'QAR'">{{formatNumber(formdata.FreightAmount, 2)}}
                                  ({{currency}})<br></span>
                                <span>{{formatNumber(formdata.FreightAmountQAR, 2)}} (QAR)</span>
                              </td>
                              <td colspan="4" class="p-1 font-12 font-w">Freight Remark :<br>
                                <div>{{formdata.FreightRemark == null ? '' : formdata.FreightRemark}}</div>
                              </td>
                            </tr>
                            <tr>
                              <td [attr.colspan]="9" style="text-align:right;" class="font-w">
                                Total
                              </td>
                              <td class="text-right p-1 font-12 font-w">
                                <span *ngIf="currency != 'QAR'">{{formatNumber(totalData.Total_DiscountValue, 2)}}
                                  ({{currency}})<br></span>
                                {{formatNumber(totalData.Total_DiscountValueQAR, 2)}} (QAR)
                              </td>
                              <td class="text-right p-1 font-12 font-w">
                                <span *ngIf="currency != 'QAR'">{{formatNumber(totalData.Total_Price,
                                  2)}} ({{currency}})<br></span> 
                                {{formatNumber(totalData.Total_PriceQAR, 2)}} (QAR)
                              </td>
                              <td class=" text-right p-1 font-12 font-w">
                                <span *ngIf="currency != 'QAR'">{{formatNumber(totalData.Total_VatValue, 2)}}
                                  ({{currency}})<br></span>
                                {{formatNumber(totalData.Total_VatValueQAR, 2)}} (QAR)
                              </td>
                              <td class="text-right p-1 font-12 font-w">
                                <span *ngIf="currency != 'QAR'">{{formatNumber(totalData.Total_PriceWithVat +
                                  formdata.FreightAmount, 2)}}
                                  ({{currency}})<br></span>
                                {{formatNumber(totalData.Total_PriceQARWithVat + formdata.FreightAmountQAR, 2)}} (QAR)
                              </td>
                              <td colspan="4">
                              </td>
                            </tr>
                            <ng-container *ngFor="let data of itemData">
                              <tr>
                                <td class="text-right p-1 font-12">{{data.BusinessVerticalName}}</td>
                                <td class="text-right p-1 font-12">{{data.BusinessCategoryName}}</td>
                                <td style="min-width: 126px;" class="text-right p-1 font-12">{{data.Code}}</td>
                                <td class="text-right p-1 font-12">{{data.Description}}</td>
                                <td class="text-right p-1 font-12">{{data.BrandName}}</td>
                                <td class="text-right p-1 font-12">{{data.UnitType}}</td>
                                <td class="text-right p-1 font-12">{{data.InquiryQuantity}}</td>
                                <td class="text-right p-1 font-12">{{data.OrderQuantity}}</td>
                                <td class="text-right p-1 font-12">{{formatNumber(data.UnitRate, 2)}}</td>
                                <td class="text-right p-1 font-12" style="min-width: 112px;">
                                  {{formatNumber(data.DiscountPer, 2)}}
                                  % <br>
                                  {{data.DiscountValue}}</td>
                                <td class="text-right p-1 font-12" style="min-width: 112px;">
                                  {{formatNumber(data.TotalPrice, 2)}}
                                  ({{currency}}) <br>
                                  {{data.TotalPriceQAR}} (QAR)</td>
                                <td class="text-right p-1 font-12">{{formatNumber(data.VatRate, 2)}} % <br>
                                  {{formatNumber(data.VatValue, 2)}} </td>
                                <td class="text-right p-1 font-12" style="min-width: 112px;">
                                  {{data.TotalPriceWithVat}}
                                  ({{currency}})<br>
                                  {{formatNumber(data.TotalPriceQARWithVat, 2)}} (QAR)</td>
                                <td>{{ data.INST ? 'Yes' : 'No' }}</td>
                                <td>{{data.TandC ? 'Yes' : 'No'}}</td>
                                <td>{{data.HandingOver ? 'Yes' : 'No'}}</td>
                                <td>{{data.Warranty ? 'Yes' : 'No'}}</td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                        <div *ngIf="itemData == 0" class="text-center">
                          No Record found.
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="2" *ngIf="payFormdata != null">
                  <a ngbNavLink>Payment Terms</a>
                  <ng-template ngbNavContent>
                    <div class="form-group">
                      <div class="table-responsive">
                        <table class="table hover table-striped table-bordered p-1 mb-0" aria-hidden="true">
                          <thead>
                            <tr>
                              <th style="min-width: 110px;">Check Box </th>
                              <th style="min-width: 195px;">Payment Terms Type</th>
                              <th style="min-width: 120px;">Base Value</th>
                              <th style="min-width: 160px;">Reported Value</th>
                              <th style="min-width: 130px;">% (Reported Value)</th>
                              <th style="min-width: 125px;">Credit Days</th>
                              <th style="min-width: 170px;">Mode Of Payment</th>
                              <th style="min-width: 175px;">Payment Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let paymentTerm of paydata">
                              <td>{{paymentTerm.CheckBox ? 'Yes' : 'No'}} </td>
                              <td>{{paymentTerm.PaymentTermsType}}</td>
                              <td>{{paymentTerm.BaseValue}}</td>
                              <td>{{paymentTerm.ReportedValue}}</td>
                              <td>{{paymentTerm.ReportedValuePercentage}}</td>
                              <td>{{paymentTerm.CreditDays}}</td>
                              <td>{{paymentTerm.ModeOfPaymentName}}</td>
                              <td>{{paymentTerm.PaymentRemark}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </ng-template>
                </li>

                <li [ngbNavItem]="3" *ngIf="payFormdata && payFormdata.Warranty == true">
                  <a ngbNavLink>Warranty List</a>
                  <ng-template ngbNavContent>
                    <div class="form-group">
                      <div class="table-responsive">
                        <table class="table hover table-striped table-bordered p-1 mb-0" aria-hidden="true">
                          <thead>
                            <tr>
                              <th style="min-width: 110px;">WARRANTY START DATE</th>
                              <th style="min-width: 195px;">WHOLE UNIT WARRANTY</th>
                              <th style="min-width: 120px;">PARTS WARRANTY</th>
                              <th style="min-width: 160px;">REMARKS</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let WarrantyList  of warrantydata">
                              <td>{{WarrantyList.WarrantyStartDate}}</td>
                              <td>{{WarrantyList.WholeUnitWarranty}}</td>
                              <td>{{WarrantyList.PartsWarranty}}</td>
                              <td>{{WarrantyList.Remark}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </ng-template>
                </li>

                <li [ngbNavItem]="4" *ngIf="requirementdata && requirementdata.PBGGaurantee == true">
                  <a ngbNavLink>Gaurantee List</a>
                  <ng-template ngbNavContent>
                    <div class="form-group">
                      <div class="table-responsive">
                        <table class="table hover table-striped table-bordered p-1 mb-0" aria-hidden="true">
                          <thead>
                            <tr>
                              <th style="min-width: 110px;">GAURANTEE PURPOSE</th>
                              <th style="min-width: 195px;">GAURANTEE PERCENTAGE</th>
                              <th style="min-width: 120px;">GAURANTEE TYPE</th>
                              <th style="min-width: 160px;">REMARKS</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let GauranteeList of guaranteedata">
                              <td>{{GauranteeList.GauranteePurpose}}</td>
                              <td>{{GauranteeList.GauranteePercentage}}</td>
                              <td>{{GauranteeList.GauranteeTypeName}}</td>
                              <td>{{GauranteeList.Remark}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </ng-template>
                </li>

                <li [ngbNavItem]="5" *ngIf="payFormdata && payFormdata.SupplierPO == true">
                  <a ngbNavLink>Supplier List</a>
                  <ng-template ngbNavContent>
                    <div class="form-group">
                      <div class="table-responsive">
                        <table class="table hover table-striped table-bordered p-1 mb-0" aria-hidden="true">
                          <thead>
                            <tr>
                              <th style="min-width: 110px;">Supplier Name</th>
                              <th style="min-width: 195px;">Expected PO/AGR Release Date</th>
                              <th style="min-width: 120px;">Supplier PO Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let SupplierList of supplierdata">
                              <td>{{SupplierList.CompanyName}}</td>
                              <td>{{SupplierList.ExpectedPOAGRReleaseDate}}</td>
                              <td>{{SupplierList.PORemark}}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div *ngIf="supplierdata == 0" class="text-center">
                          No Record found.
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>

                <li [ngbNavItem]="6" *ngIf="payFormdata && payFormdata.SubContractor == true">
                  <a ngbNavLink>SubContractor List</a>
                  <ng-template ngbNavContent>
                    <div class="form-group">
                      <div class="table-responsive">
                        <table class="table hover table-striped table-bordered p-1 mb-0" aria-hidden="true">
                          <thead>
                            <tr>
                              <th style="min-width: 110px;">Sub Contractor Name</th>
                              <th style="min-width: 195px;">Expected PO/AGR Release Date</th>
                              <th style="min-width: 120px;">Sub Contractor PO Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let SubContractorList of contractdata">
                              <td>{{SubContractorList.CompanyName}}</td>
                              <td>{{SubContractorList.ExpectedPOAGRReleaseDate}}</td>
                              <td>{{SubContractorList.PORemark}}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div *ngIf="contractdata == 0" class="text-center">
                          No Record found.
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>

                <li [ngbNavItem]="7" *ngIf="commercialdata && commercialdata.CreditSplit == true">
                  <a ngbNavLink>Credit List</a>
                  <ng-template ngbNavContent>
                    <div class="form-group">
                      <div class="table-responsive">
                        <table class="table hover table-striped table-bordered p-1 mb-0" aria-hidden="true">
                          <thead>
                            <tr>
                              <th style="min-width: 110px;">Credit Split (%)</th>
                              <th style="min-width: 195px;">Credit Person Name</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let CreditList of creditdata">
                              <td>{{CreditList.CreditSplitPercentage}}</td>
                              <td>{{CreditList.CreditPersonName}} ({{CreditList.CreditPersonId}})</td>
                            </tr>
                          </tbody>
                        </table>
                        <div *ngIf="creditdata == 0" class="text-center">
                          No Record found.
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>

                <li [ngbNavItem]="8" *ngIf="CPoCListdata.length > 0">
                  <a ngbNavLink>Client Contacts</a>
                  <ng-template ngbNavContent>
                    <div class="form-group">
                      <div class="table-responsive">
                        <table class="table table-bordered p-0 mb-0" aria-hidden="true">
                          <thead>
                            <tr>
                              <th style="min-width: 180px;">Contact Name</th>
                              <th style="min-width: 210;">Designation</th>
                              <th style="min-width: 200px;">City & Country</th>
                              <th style="min-width: 160px;">Email</th>
                              <th style="min-width: 130px;">Mobile</th>
                              <th style="min-width: 125px;">Contact Owner</th>
                              <th style="min-width: 70px;">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let data of CPoCListdata">
                              <td>
                                <a href="javascript:void(0);"
                                  (click)="viewCPoCDetail(ContactDetails, data.ClientContactId)">
                                  {{data.ContactName}}
                                </a>
                              </td>
                              <td>{{data.Designation}}</td>
                              <td><span *ngIf="data.CityName != ''">{{data.CityName}},</span> {{data.CountryName}}</td>
                              <td>{{data.Email}}</td>
                              <td>{{data.Mobile}}</td>
                              <td>{{data.ContactOwner}}</td>
                              <td>{{data.Status}}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div *ngIf="CPoCListdata.length == 0" class="text-center">
                          No Record found.
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>
              </ul>

              <div [ngbNavOutlet]="nav" class="mt-2"></div>

            </ng-template>

            <ng-template #ContactDetails>
              <div class="modal-body position-relative">
                <span class="position-absolute end-0 top-0 mr-3 mt-3 cursor-pointer"><span class="mdi mdi-close fs-20"
                    (click)="modalRef.hide()"></span></span>
                <h5 class="mb-3 pb-3 border-bottom  text-green"> Contact Information</h5>
              <div class="ContectDetailContainer">
                <div class="row m-0 w-100 odd">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Contact Name:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.ContactName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Mobile:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.Mobile}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Landline:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.Landline}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row w-100 m-0 even">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Whatsapp Number</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.WhatsappNumber}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Email:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.Email}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Country:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.CountryName}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row w-100 m-0 odd">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">State:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.StateName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">City:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.CityName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Date of Birth:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.DateOfBirth}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row w-100 m-0 even">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Address1:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.Address1}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Address2:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.Address2}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row w-100 m-0 even">
                </div>

                <h5 class="mb-3 pb-2 border-bottom mt-3 text-green">Company Information</h5>
                <div class="row w-100 m-0 odd">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Company:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.CompanyName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Designation:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.DesignationName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> Contact Owner:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.UserName}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row w-100 m-0 even">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> Nationality:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.NationalityName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Religion:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.ReligionName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> Language:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.LanguageName}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row w-100 m-0 odd">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> Pro Reservation:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.ProReservationName}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Gender:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.Gender}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> Factory Visit Type/Comments:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.FactoryVisitComments}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row w-100 m-0 even">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> Comments:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata.Comments}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> VVIP:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold"> {{CPoCDetaildata.IsVVIP == false ? "No": "Yes"}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label"> Factory Visit:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold"> {{CPoCDetaildata.IsFactoryVisit == false ? "No": "Yes"}}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <h5 class="mb-3 pb-2 border-bottom mt-3 text-green">Status Remark</h5>

                <div class="row w-100 m-0 odd">

                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Status:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata?.StatusName}}</p>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                      <label class="col-sm-4 col col-form-label">Remark:</label>
                      <div class="col-sm-8 col">
                        <p class="pt-2 mb-0 font-weight-bold">{{CPoCDetaildata?.StatusRemark}}</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              </div>
            </ng-template>

          </ngb-tab>

          <ngb-tab id="tab-selectbyid91" *ngIf="permission.OrderReview_View==1 || userRId==1">
            <ng-template ngbTabTitle>
              <div (click)="tabclick1(id)">
                Order Review Attachments
              </div>
            </ng-template>
            <ng-template ngbTabContent>
              <app-detailattachment></app-detailattachment>
            </ng-template>
          </ngb-tab>

          <ngb-tab id="tab-selectbyid12">
            <ng-template ngbTabTitle>
              <div> Activity History </div>
            </ng-template>
            <ng-template ngbTabContent>
              <div class="activity-history mt-3">
                <ul>
                  <li *ngFor="let detail of orderActivityHistory">
                    <div>
                      <span><i class="fa fa-calendar-check-o"></i>
                        {{ detail.CreatedDate }}</span>
                      <i class="fa fa-user-circle"></i>{{ detail.userName }}
                    </div>
                    <p>{{ detail.Type }}</p>
                  </li>
                  <li *ngIf="orderActivityHistory == ''">
                    <div></div>
                    <p class="text-center">No Data Found</p>
                  </li>
                </ul>
              </div>
              <div class="spinner-border" role="status" *ngIf="loader">
                <span class="sr-only">Loading...</span>
              </div>
              <div class="text-center position-relative" *ngIf="showMore">
                <a href="javascript:void(0);" (click)="showMoreactivity()" class="read-more read-more-top new-show-less"
                  placement="top">
                  <span>
                    <img src="{{ default }}" class="img-fluid" alt="..." width="21" />
                    Show More
                  </span>
                </a>
              </div>
            </ng-template>
          </ngb-tab>

          <ngb-tab id="tab-selectbyid10"
            *ngIf="(permission.OrderReview_View==1 || userRId==1) && Status != 'Pending MTI'">
            <ng-template ngbTabTitle>
              <div (click)="tabclick(id)">
                Approved PDF
              </div>
            </ng-template>
            <ng-template ngbTabContent>
              <app-detailapprovepdf></app-detailapprovepdf>
            </ng-template>
          </ngb-tab>

        </ngb-tabset>
      </div>
    </div>
  </div>
</div>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>